<template>
	<div v-loading='loading'>
    <el-row :gutter="20" style="margin-bottom: 20px;">
      <el-col :span="5">
        <el-button type="primary" @click="jump('/roleManager/roleAdd')">{{$t('menuConfig.role.addRole')}}</el-button>
      </el-col>
    </el-row>

    <el-table :data="dataList"   border  ref="arrdata">
      <!-- <el-table-column type="index" :label="$t('menuConfig.role.no')" width="70"></el-table-column>  -->
      <el-table-column prop="rolename" :label="$t('menuConfig.role.name')" width="200"></el-table-column>
      <el-table-column prop="memo" :label="$t('menuConfig.role.mark')" width="250"></el-table-column>
      <el-table-column :label="$t('menuConfig.role.model')">
        <template slot-scope="scope"> <!-- v-if="roleRightName.length > 0" -->
          <!-- <div style="padding-top:13px;padding-bottom:13px;">
            <el-tag
              style="margin-top: 3px;margin-right: 5px;margin-bottom: 3px;"
              type="primary"
              v-for="name in rights[scope.$index]"
              :key="name"
              v-if='name'
            >
              {{name}}
            </el-tag>
          </div> -->
          
          <el-tag v-for='(item,index) in rights[scope.$index]' :key="index" type="primary" v-if='item'>{{item}}</el-tag>
          
          
        </template>
      </el-table-column>

      <el-table-column :label="$t('app_operate')" width="130">
        <template slot-scope="scope">
          <template v-if="scope.row.roleid!=='165d6769-2ff9-4ee0-9edc-be17e52eed07'">
          <!--<template>-->
            <!-- <el-button size="small" @click.stop="editRow(scope.row)" type="text">{{$t('mao_global.btn.edit')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('mao_global.btn.edit')" placement="top">
              <el-button type='text' @click.stop="editRow(scope.row)"><i class="fa fa-pencil" style=""></i></el-button>
            </el-tooltip>




            <!-- <el-button size="small" type="text" @click.stop="jump('/roleManager/roleUpdate/' + scope.row.roleid)">{{$t('menuConfig.role.updatePermission')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('menuConfig.role.updatePermission')" placement="top">
              <el-button type='text' @click.stop="jump('/roleManager/roleUpdate/' + scope.row.roleid)"><i class="fa fa-key" style=""></i></el-button>
            </el-tooltip>

            <!-- <el-button size="small" type="text" @click='showRoleDialog(scope.row)'>{{$t('app_roleAllot')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('app_roleAllot')" placement="top">
              <el-button type='text' @click='showRoleDialog(scope.row)'><i class="fa fa-user" style=""></i></el-button>
            </el-tooltip>

            <!-- <el-button size="small" @click.stop="deleteRow(scope.row.roleid,scope.row.rolename)" type="text">{{$t('mao_global.btn.delete')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('mao_global.btn.delete')" placement="top">
              <el-button type='text' @click.stop="deleteRow(scope.row.roleid,scope.row.rolename, scope.$index)"><i class="fa fa-trash" style="color:#FF4949"></i></el-button>
            </el-tooltip>
          </template>
        </template>
      </el-table-column>
    </el-table>


    <!--编辑摸态框-->
    <el-dialog class='gDia' :title="$t('menuConfig.role.editRole')" :visible.sync="editInfoVisible">
      <el-form ref="editForm" id="editForm" :model="editInfoPreViewData" :rules="editRules">
        <input type="hidden" v-model="editInfoPreViewData.roleId"/>
        <el-form-item :label="$t('menuConfig.role.name')" label-width="120" prop="roleName">
          <el-input  auto-complete="off" v-model="editInfoPreViewData.roleName"></el-input>
        </el-form-item>
        <el-form-item label="描述" label-width="120" prop="memo">
          <el-input type="textarea" v-model="editInfoPreViewData.memo"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editInfoVisible = false">{{$t('mao_global.btn.cancel')}}</el-button>
        <el-button type="primary" @click="updateRoleInfo()">{{$t('mao_global.btn.ok')}}</el-button>
      </div>
    </el-dialog>
    <!--end 编辑摸态框-->

    <!--权限摸态框-->
    <el-dialog class='gDia' :title="$t('app_roleAllot')" :visible.sync="roleAllot">
      <el-table
        ref="multipleTable"
        :data="roleSubList"
        border
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange">

        <el-table-column
          align='center'
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          align='center'
          prop="roleName"
          :label="$t('app_roleName')"
          width=''>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="savePermission()">{{$t('app_sure')}}</el-button>
      </span>

    </el-dialog>
    <!--end 权限摸态框-->

	</div>

</template>

<script>
  import axios from 'axios'
  import { baseurl } from '../../api/url'
	export default{
    data(){
			return {
        // 角色选择数组
        roleMultipleSelect: [],
        // 显示等待动画
        loading: false,
        // 角色分配框显/隐
        roleAllot: false,
        // 角色子权限列表数据
        roleSubList: [
        ],
				// 数据返回的结果集
        dataList:[],
        //角色名列表
        roleRightNames: [],
        //权限表
        rights: [],
        // 当前页
        currentPage: 1,
        // 总记录数
        totalRecords: 0,
        // 是否显示编辑摸态框
        editInfoVisible: false,
        // 编辑角色时候的预览表单
        editInfoPreViewData: {
          roleId: null,
          roleName: null,
          memo: null
        },
        editRules: {
            roleName:[
            	{ required: true, message: this.$t('menuConfig.role.notBlankName'), trigger:'blur'}
            ]
        },
        selectRoleId: null
      }
		},
    mounted () {
    	var that = this
      that.fetchData(1)
		},
		methods:{
      toggleSelection(rows) {

        let r = rows.filter((v)=>{
          if (v.type===1) return true
        })

        if (r) {
          r.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        }

      },
      savePermission () {

        var that = this

        let subRoleIds = ""
          if (this.roleMultipleSelect) {
          this.roleMultipleSelect.forEach((item)=>{
            subRoleIds += item.roleId + ","
          })
          subRoleIds = (subRoleIds) ? subRoleIds.substring(0,subRoleIds.length-1) : ""
        }

        this.$editRoleMgList(this.selectRoleId,subRoleIds,(res)=>{
          // 成功
          // todo 提示信息
          that.roleAllot = false
        },(err)=>{
          // 失败
        })
      },
      handleSelectionChange(val) {
        console.log(val)
        this.roleMultipleSelect = val;
      },
      showRoleDialog (row) {
        this.selectRoleId = row.roleid;
        this.$roleMgList(row.roleid, (res) => {
          this.loading = false
          if (res.status === 200) {
            this.roleAllot = true
            this.roleSubList = res.data
            var _this = this
            this.roleMultipleSelect = []
            setTimeout(() => {
              _this.toggleSelection(this.roleSubList)
            }, 100)
            //console.log(res)
//            _this.dateFormat = res.data
          } else {
            this.$message.error(res.message)
          }
        }, (error) => {
          this.loading = false
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      jump (uri) {
      	this.$router.push({path: uri})
      },
    	// 执行更新角色
    	updateRoleInfo () {
        var that = this
        that.editInfoVisible = false

        axios.post(`${baseurl}/role/editRole.do`,that.editInfoPreViewData).then(res=>{
          if (res.data && res.data.status && res.data.status === 200) {
            that.$message(this.$t('menuConfig.role.updateSuccess'))
            that.fetchData(1)
          }
        })

      },
    	// 修改一行记录
      editRow (record) {

      	var that = this

        that.editInfoPreViewData = {
            roleId: record.roleid,
            roleName: record.rolename,
            memo: record.memo
        }

      	that.editInfoVisible = true
      },
      // 删除一行记录
      deleteRow (roleId,rolename, index) {
      	var that = this
        that.$confirm(this.$t('mao_global.tip.confirmDelete') + rolename + this.$t('mao_global.tip.notReset'), this.$t('mao_global.tip.text'), {
          confirmButtonText: this.$t('mao_global.btn.ok'),
          cancelButtonText: this.$t('mao_global.btn.cancel'),
          type: 'warning'
        }).then(() => {
          axios.post(`${baseurl}/role/delete.do`,{roleId: roleId}).then(res=>{
            if (res.data && res.data.status && res.data.status === 200) {
              // 删除成功
              
              that.$message(this.$t('menuConfig.role.deleteSuccess'))
              // 初始化数据
              that.fetchData(1)
            }
          })
        }).catch(() => {

        }); // end $confirm
      },
			// 拉取数据
      // 传入请求的页数
      fetchData (page){
      	var that = this
        var params = {"page":page,"rows":100,distributorid:''}
        axios.post(`${baseurl}/role/list.do`,params).then(res=>{
          if (res.data) {
            if (!res.data.status) return 
            if (res.data.status !== 200) return
            
            var rights = []
            res.data.data.forEach((vl) => {
              rights.push(vl.roleRightsName.split(','))
            })
            console.log(rights)
            that.rights = rights
            that.dataList = res.data.data
            that.totalRecords = res.data.total;
            that.currentPage = page;
          }
        })
      },
      roleRightNamesHandler: function(names) {
        
        var roleRightNames = names.roleRightsName.split(',')
        return roleRightNames
 
      }
		}
	}
</script>



// WEBPACK FOOTER //
// roleManager.vue?0c3206d2